import React, { useEffect, useState } from 'react';
import api from '../../../services/publicApi';

const formatPrice = value => `${new Intl.NumberFormat('ru-RU').format(Number(value))} ₽`;

export default function DeliveryPicker({ items, disabled, onChange, selectedQuote, shippingPaymentMode }) {
    const [query, setQuery] = useState('');
    const [cities, setCities] = useState([]);
    const [city, setCity] = useState(null);
    const [points, setPoints] = useState([]);
    const [point, setPoint] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [retry, setRetry] = useState(0);
    const itemKey = JSON.stringify(items.map(item => ({ variant_id: item.variant_id, quantity: item.quantity })));

    useEffect(() => {
        if (city || query.trim().length < 2) { setCities([]); if (!city) setBusy(false); return undefined; }
        let cancelled = false;
        const timer = setTimeout(async () => {
            setBusy(true); setError('');
            try {
                const result = await api.delivery.cities(query.trim());
                if (!cancelled) setCities(result);
            } catch {
                if (!cancelled) setError('Не удалось найти город. Попробуйте ещё раз.');
            } finally { if (!cancelled) setBusy(false); }
        }, 350);
        return () => { cancelled = true; clearTimeout(timer); };
    }, [query, city, retry]);

    useEffect(() => {
        if (!city) return undefined;
        let cancelled = false;
        setBusy(true); setError(''); setPoints([]);
        api.delivery.points(city.code).then(result => {
            if (!cancelled) setPoints(result);
        }).catch(() => { if (!cancelled) setError('Не удалось загрузить пункты выдачи. Попробуйте ещё раз.'); })
            .finally(() => { if (!cancelled) setBusy(false); });
        return () => { cancelled = true; };
    }, [city, retry]);

    useEffect(() => {
        if (!city || !point) return undefined;
        let cancelled = false;
        setBusy(true); setError('');
        api.delivery.quote({ delivery_method: 'cdek_pvz', recipient_city_code: city.code,
            delivery_point_code: point, shipping_payment_mode: shippingPaymentMode, items: JSON.parse(itemKey) }).then(quote => {
                if (!cancelled) onChange(quote);
            }).catch(() => {
                if (!cancelled) setError('Не удалось рассчитать доставку. Попробуйте ещё раз или выберите другой пункт.');
            }).finally(() => { if (!cancelled) setBusy(false); });
        return () => { cancelled = true; };
        // onChange is a stable state setter owned by PurchaseForm.
    }, [city, point, itemKey, retry, onChange, shippingPaymentMode]);

    if (disabled && selectedQuote) return <div className="shop-delivery-selected">
        <strong>Пункт выдачи СДЭК</strong><p>{selectedQuote.delivery_point_address}</p>
        <p>{selectedQuote.shipping_payment_mode === 'prepaid_fixed' ? `Доставка: ${formatPrice(selectedQuote.online_charge)}. Включена в оплату на сайте.` : `Доставка: ориентировочно ${formatPrice(selectedQuote.customer_charge)}. Оплата при получении в СДЭК.`}</p>
    </div>;

    return <div className="shop-form-group shop-delivery-picker">
        <label htmlFor="shop_city">Город доставки *</label>
        <input id="shop_city" value={query} disabled={disabled} autoComplete="off" placeholder="Начните вводить название города"
            onChange={event => { setQuery(event.target.value); setCity(null); setPoint(''); setPoints([]); onChange(null); }} />
        {cities.length > 0 && <ul className="shop-city-results" aria-label="Найденные города">{cities.map(candidate => <li key={candidate.code}>
            <button type="button" disabled={disabled} onClick={() => {
                setCity(candidate); setQuery(`${candidate.city}${candidate.region ? `, ${candidate.region}` : ''}`); setCities([]); setPoint(''); onChange(null);
            }}>{candidate.city}{candidate.region ? `, ${candidate.region}` : ''}</button>
        </li>)}</ul>}
        {city && <>
            <label htmlFor="shop_pvz">Пункт выдачи СДЭК *</label>
            <select id="shop_pvz" value={point} disabled={disabled || busy || !points.length}
                onChange={event => { setPoint(event.target.value); onChange(null); }}>
                <option value="">Выберите пункт выдачи</option>
                {points.map(item => <option value={item.code} key={item.code}>{item.address} ({item.code})</option>)}
            </select>
            {point && <p className="shop-field-hint">{points.find(item => item.code === point)?.work_time}</p>}
            {!busy && !error && !points.length && <p>В этом городе нет доступных пунктов. Выберите другой город.</p>}
        </>}
        {busy && <p role="status">Загружаем данные СДЭК...</p>}
        {city && point && !busy && !selectedQuote && !error && <button type="button" disabled={disabled} onClick={() => setRetry(value => value + 1)}>Обновить расчёт доставки</button>}
        {error && <div role="alert">{error} <button type="button" disabled={disabled} onClick={() => setRetry(value => value + 1)}>Повторить</button></div>}
        {selectedQuote && <div className="shop-delivery-selected" role="status">
            <strong>{selectedQuote.delivery_point_address}</strong>
            <p>{selectedQuote.shipping_payment_mode === 'prepaid_fixed' ? `Доставка: ${formatPrice(selectedQuote.online_charge)}. Включена в оплату на сайте.` : `Доставка: ориентировочно ${formatPrice(selectedQuote.customer_charge)}. Оплата при получении в СДЭК.`}</p>
            {selectedQuote.period_min && <p>Ориентировочно {selectedQuote.period_min}–{selectedQuote.period_max} дн. после отправки.</p>}
        </div>}
    </div>;
}
